var map = {
	"./feedback1-3.jpg": "7422",
	"./feedback10-3.jpg": "a76e",
	"./feedback2-3.jpg": "134f",
	"./feedback3-3.jpg": "bfaf",
	"./feedback4-3.jpg": "c180",
	"./feedback5-3.jpg": "5823",
	"./feedback6-3.jpg": "3c24",
	"./feedback7-3.jpg": "a46a",
	"./feedback8-3.jpg": "9019",
	"./feedback9-3.jpg": "bc1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a16";